const Audio = {
  Toggle: "audio:toggle",
  SetVolume: "audio:set-volume",
}

const Scroll = {
  Section: {
    StartUpdate: "scroll:section:start-update",
    UpdateStop: "scroll:section:update-stop",
  },
}

const Email = {
  Click: "email:click",
  Hover: "email:hover",
  Out: "email:out",
}

const Lenis = {
  Initialized: "lenis:initialized",
}

const Menu = {
  itemClick: "menu:item-click",
  hover: "menu:hover",
  out: "menu:out",
  click: "menu:click",
  open: "menu:open",
  close: "menu:close",
}

const Loader = {
  Entered: "loader:entered",
  Exiting: "loader:exiting",
  Exited: "loader:exited",

  /**
   * Fired when all sections are updated
   * This is done at before the curtain is removed
   * and ensures a better section-transition performance
   */
  AllSectionsUpdated: "loader:all-sections-updated",

  /**
   * Fired when the resources are ready and the curtain is removable.
   * Curtain is not removed yet, but the resources are ready.
   */
  CurtainRemovable: "loader-curtain:removable",

  CurtainStartedRemoving: "loader-curtain:started-removing",

  /**
   * The curtain is removed and the experience is visible.
   */
  CurtainRemoved: "loader-curtain:removed",

  /**
   * Fired during loading with combined progress (global + audio + sections).
   * Payload: { percentage: number } (0–100).
   */
  Progress: "loader:progress",

  EnterCTA: {
    Click: "enter-cta:click",
    Hover: "enter-cta:hover",
    Out: "enter-cta:out",
  },
}

const About = {
  Entered: "about:entered",
  Exiting: "about:exiting",
  Scroll: "about:scroll",
  LeafReady: "about-leaf:ready",

  EnterCTA: {
    Click: "about-cta:click",
    Hover: "about-cta:hover",
    Out: "about-cta:out",
  },

  LeaveCTA: {
    Click: "about-cta:click",
    Hover: "about-cta:hover",
    Out: "about-cta:out",
  },
}

const Works = {
  /**
   * Used before the enter animation starts, to set the animation type
   */
  BeforeEnter: "works:before-enter",
  /**
   * Triggered during the first screen height of the Works section
   */
  Entering: "works:entering",
  /**
   * Triggered when the intro texts are left
   */
  LeaveIntroTexts: "works:leave-intro-texts",
  Exiting: "works:exiting",
  EnteringFinished: "works:entering-finished",
  EnteringBack: "works:entering-back",
  Entered: "works:entered",
  LeaveWorks: "works:leave-works",
  LeaveWorksEntered: "works:leave-works-entered",
  ThumbEntered: "works:thumb-entered",
  AllThumbsLeft: "works:all-thumbs-left",
  Scroll: "works:scroll",

  SlideEnter: "works-slide:enter",

  /**
   * Fired when the section listerners are set
   */
  SectionReady: "works-section:ready",
}

const Project = {
  Entered: "project:entered",
  Exiting: "project:exiting",
  Scroll: "project:scroll",
  VisitWebsiteCTA: {
    Hover: "project-visit-website:hover",
    Out: "project-visit-website:out",
  },
  CloseCTA: {
    Click: "project-close:click",
    Hover: "project-close:hover",
    Out: "project-close:out",
  },
}

const Guestbook = {
  BeforeEnter: "guestbook:before-enter",
  Exiting: "guestbook:exiting",
  Entering: "guestbook:entering",
  Entered: "guestbook:entered",
  Scroll: "guestbook:scroll",

  Memory: {
    Click: "guestbook-memory:click",
    Close: "guestbook-memory:close",
    Add: "guestbook-memory:add",
    Hover: "guestbook-memory:hover",
    Out: "guestbook-memory:out",
    AddClosed: "guestbook-memory:add-closed",
    AddSent: "guestbook-memory:add-sent",
  },
}

const Contact = {
  BeforeEnter: "contact:before-enter",
  Entering: "contact:entering",
  Entered: "contact:entered",
  Left: "contact:left",
  Hover: "contact:hover",
  Out: "contact:out",
  EmailCTA: {
    Click: "contact-email-cta:click",
  },
  TelegramCTA: {
    Click: "contact-telegram-cta:click",
  },
  XCTA: {
    Click: "contact-x-cta:click",
  },
  LinkedInCTA: {
    Click: "contact-linkedin-cta:click",
  },
  RestartCTA: {
    Click: "contact-restart-cta:click",
  },
}

export {
  About,
  Audio,
  Contact,
  Email,
  Guestbook,
  Lenis,
  Loader,
  Menu,
  Project,
  Scroll,
  Works,
}
